export default {
	"capacityPool": {
		"partnerName": "所属",
		"plateType": "车牌类型",
		"hasGps": "是否有GPS",
		"capacityInfo": "运力信息",
		"addCapacity": "新建运力",
		"routeType": "线路类型"
	},
	"motorcade": {
		"name": "车队名",
		"driverNum": "司机数",
		"vehicleNum": "车辆数",
		"partnerName": "承运伙伴",
		"capatainName": "车队长",
		"addMotorcade": "新建车队",
		"motorcadeInfo": "车队信息",
		"requirement": "车辆维护要求",
		"depreciation": "折旧要求",
		"maintenance": "维保要求",
		"insurance": "保险要求",
		"vehicleCertificate": "车辆证件要求",
		"pictureAttachment": "照片附件",
		"certificateRequirement": "司机证件要求",
		"driverCertificateIsRequired": "司机证件要求名称必填",
		"vehicleCertificateisRequired": "车辆证件要求名称必填",
		"certificateNameNorNull": "车辆证件要求证件名称不能为空！",
		"dricerNameNorNull": "司机证件要求证件名称不能为空！"
	},
	"ourdriver": {
		"drivingAgeMonth": "驾龄范围",
		"driverName": "司机名字",
		"drivingAge": "驾龄",
		"zeroMonth": "0个月",
		"driverLicenseType": "驾照类型",
		"defaultVehiclePlate": "默认车辆",
		"baseWage": "基本工资",
		"newDriver": "新建司机",
		"licenseDate": "初次领证日期",
		"defaultVehicleNoTips": "请选择车牌号",
		"score": "驾照分数",
		"importFailed": "导入失败",
		"driverInfo": "司机信息",
		"startAndEndDateTips": "证件失效日期必须大于证件生效日期"
	},
	"ourvehicle": {
		"refuelRecord": "加油/充电记录",
		"vehicleAge": "车龄",
		"vehicleValue": "原值(元)",
		"netValue": "净值(元)",
		"equipmentPosition": "设备定位",
		"newVehicle": "新建车辆",
		"plateLicenseColor": "车牌颜色",
		"vehicleRegistDate": "车辆注册日期",
		"gpsFee": "GPS年费用",
		"importCar": "导入车辆",
		"importRefuel": "导入加油记录",
		"inputCarNoTips": "请输入正确的车牌号",
		"carNoOrVehicleTypeCodeTips": "车牌号，车型没有完全传递到后台",
		"year": "年",
		"month": "里程月份",
		"aYear": "1年",
		"noLocationInfo": "暂无位置信息",
		"certificateAdmin": "证件管理",
		"reach": "到",
		"certificateFee": "年检金额",
		"fuelPerson": "加油/充电人",
		"fuelDate": "加油/充电日期",
		"fuelVolumn": "加油/充电量(升/度)",
		"oilType": "油品类型",
		"fuelMoney": "加油/充电金额(元)",
		"payType": "支付方式",
		"maintenanManage": "维保管理",
		"maintenancePlan": "保养计划",
		"nextMaintenanceMileage": "下次保养里程",
		"nextMaintenanceTime": "下次保养日期",
		"maintenancePeriod": "保养周期",
		"upkeepCost": "保养总费",
		"repairCost": "维修总费用",
		"repairAndUpkeepCost": "维保总额",
		"addMaintenanManage": "维保记录",
		"maintenanceType": "类型",
		"maintenanceDt": "维保日期",
		"remark": "描述",
		"amount": "维修金额(元)",
		"repairMan": "报修人",
		"depreciationOfAssets": "资产折旧",
		"premiumPeriod": "报废期限(月)",
		"salvage": "残值率",
		"inputRangeTips": "请输入0~1.0000的数字",
		"depreciationValue": "累计折旧(元)",
		"residualValue": "残值(元)",
		"insuranceLog": "保险记录",
		"insuranceType": "保险类型",
		"premium": "保险费用(元)",
		"mileageLog": "里程记录",
		"mileage": "总里程数",
		"currentMonthMileage": "当月里程数",
		"monthMileageInfo": "月里程",
		"monthMileage": "里程数(km)",
		"totalMileage": "月末里程(km)",
		"mileageJournal": "里程日志",
		"methodCode": "计算方法",
		"distance": "里程（千米）",
		"violationRecords": "违章记录",
		"violationContent": "违章内容",
		"violationAddress": "地点",
		"violationTime": "违章时间",
		"pointsDeducted": "扣分",
		"penalty": "罚款",
		"driverName": "违章司机",
		"checkPersonName": "确认人",
		"regularLine": "常运线路",
		"line": "线路",
		"capacityPool": "运力池",
		"certificateInfo": "证件信息",
		"violationInfo": "违章信息",
		"curingInfo": "养护信息",
		"max500": "500字以内",
		"pleaseAddAttachments": "请添加附件",
		"certificateFeeTips": "年检金额输入错误,请输入0~9999999.99之间的数值，保留两位小数",
		"isTrunkTips": "线路类型为干线时，始发城市和目的城市不能相同！",
		"currentMileageTips": "当前里程数不能大于总里程数",
		"dateTips": "失效日期必须大于生效日期",
		"oldValueInputError": "原值输入错误,请输入0~9999999.99之间的数值，保留两位小数",
		"gpsFeeTips": "GPS年费用输入错误,请输入0~9999999.99之间的数值，保留两位小数",
		"premiumPeriodTips": "报废期限输入错误,请输入0~1000之间的整数",
		"salvageTips": "残值率输入错误,请输入0~1之间的小数或整数，保留四位小数",
		"maintenancePeriodTips": "保养周期输入错误,请输入正整数"
	},
	"partner": {
		"quotationTemplate": "报价模板",
		"businessRelations": "关系",
		"partnerType": "是否在线",
		"offer": "必须有报价",
		"nLike": "伙伴名称\\简称\\编码",
		"partnerName": "名称",
		"billingObject": "计费方",
		"comments": "业务说明",
		"partnerCode": "编号",
		"billingTips": "请选择计费方",
		"receiptDtSize": "回单时长",
		"receiptDt": "当月截单日期",
		"outerCode": "外部编码",
		"outerSourceCode": "外部来源",
		"companyGroup": "所属企业",
		"day": "天",
		"number": "号",
		"batchWorking": "允许批量提送货",
		"belongToUser": "所属用户",
		"heIsyours": "他是您的",
		"heUseThisPlatform": "他也使用此平台",
		"heNotUseThisPlatform": "他没使用此平台",
		"partnerNameTips": "输入企业名称/简称",
		"partnerCodeTips": "请输入编码(最长20字)",
		"shortNameTips": "请输入简称(最长50字)",
		"salesman": "业务员",
		"existential": "已存在。",
		"application": "申请",
		"saveAddNext": "请填写并保存成功联系人信息后，才可添加下一条",
		"partnerCodeNotNullTips": "编号不能为空。",
		"acceptTips": "确定要接受吗?",
		"partnerInvitedTips": "请将邀请地址复制给您的伙伴",
		"copyLink": "复制链接",
		"inviteTips": "邀请他加入平台"
	},
	"product": {
		"productNameAndCode": "产品名称\\编码",
		"superiorProduct": "上级产品",
		"level": "层数",
		"createChild": "新建子产品",
		"addNewProduct": "新建新产品",
		"rangeValueMustBe": "范围值必须为",
		"numberBetween": "之间的数字！",
		"maxAndminTips": "【上限值】必须大于或等于【下限值】！",
		"defaultValueWithinRange": "的默认值必须为范围值内的数字！"
	},
	"project": {
		"nameOrNoTips": "项目名称\\编码",
		"projectName": "名称",
		"serviceContent": "服务内容",
		"addService": "添加服务项",
		"essentialService": "必要服务",
		"pleaseSelectMotherboard": "请选择报价母板",
		"orderContent": "单据内容",
		"addNewItem": "新建项目",
		"sureAgree": "确定要同意吗?",
		"agreed": "已同意!",
		"suspendTips": "确定要暂停吗?",
		"toBeConfirmedTips": "此在线项目已经发起，待对方确认!",
		"inputTips": "请输入大于0的数字，且最多两位小数！",
		"coldStorage": "冷藏",
		"minWeightTips": "重量最小值为0.001~99999.999之间的数字！",
		"maxWeightTips": "重量最大值为0.001~999999.999之间的数字！",
		"minVolumeTips": "体积最小值为0.001~999.999之间的数字！",
		"maxVolumeTips": "体积最大值为0.001~999.999之间的数字！",
		"minGoodsValueTips": "声明货值最小值为0.00~9999999.99之间的数字！",
		"maxGoodsValueTips": "声明货值最大值为0.00~9999999.99之间的数字！",
		"minPackingQtyTips": "外包装数最小值为1~999999999之间的数字！",
		"maxPackingQtyTips": "外包装数最大值为1~999999999之间的数字！",
		"maxDistributionOrder": "最大配送次序",
		"betweenMaxiAndMini": "的默认值必须为最大值到最小值之间的数字！",
		"areYouSureToSave": "确定保存吗?",
		"noMotherboardInfo": "无法识别的母板信息。",
		"multipleMotherboardInfo": "重复的母板信息",
		"noServiceInfo": "无法识别的服务信息。",
		"multipleServiceInfo": "重复的服务信息"
	},
	"site": {
		"stationNoOrName": "站点编码/名称",
		"ownSite": "自有站点",
		"sharedSite": "共享站点",
		"stationOwn": "共享属性",
		"locationStatus": "地图定位",
		"stationNo": "站点编码",
		"stationName": "站点名称",
		"province": "省",
		"city": "市",
		"district": "县（区）",
		"siteStaff": "站点人员",
		"operators": "作业人员",
		"pleaseSelectOperators": "请选择作业人员",
		"addSite": "新建站点",
		"pleaseSiteName": "请输入站点名称",
		"stationTypeTips": "请选择站点类型",
		"entrepotCreate": "是否集散中心",
		"channelNum": "道口数",
		"pleaseInputChannelNum": "请输入道口数",
		"pleaseInputSiteNo": "请输入站点编码",
		"priority": "优先级",
		"loadSpeed": "装卸速度",
		"loadSpeedUnit": "装卸速度(千克/分)",
		"workTime": "工作时间窗",
		"limitLength": "最大车型长度",
		"limitLengthUnit": "最大车型长度(米)",
		"checkTime": "交接时间(分)",
		"locked": "是否锁定",
		"addrRange": "地点范围(米)",
		"stationAddress": "地址",
		"yes": "有",
		"no": "无",
		"salesman": "业务员",
		"alreadyExists": "已存在",
		"has": "是",
		"addressChange": "地址信息已变更，请[重新定位]后再提交！",
		"location": "地点位置",
		"reposition": "重新定位",
		"inputAddressTips": "请填写省市区和地址信息！",
		"failedToLocate": "定位失败，请确认地址信息后重试！"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/our/our.js